export default {"src":"/_next/static/media/hiring-markets.16d60081.svg","height":377,"width":448,"blurWidth":0,"blurHeight":0};